<script setup>
import { CheckIcon } from '@heroicons/vue/24/outline'

import BrandButton from '@/components/ui/BrandButton.vue'
import SectionHeading from '@/components/ui/SectionHeading.vue'
import { usePlanSelection } from '@/composables/usePlanSelection'
import { addonServices, addonsStartingPrice } from '@/data/services'

const { selectPlan } = usePlanSelection()

const addon = addonServices[0]

const requestAddon = () => {
    selectPlan({ id: addon.id, type: 'addon', name: addon.name, price: addonsStartingPrice })
}
</script>

<template>
    <section
        class="bg-white py-20 md:py-28"
        id="doplnkove-sluzby"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading
                title="Doplňkové služby"
                lede="Jednorázové zpracování bez nutnosti celoroční spolupráce."
            />

            <article
                class="mt-12 flex flex-col rounded-2xl border border-zinc-200 bg-white p-8 md:flex-row md:gap-12 md:p-10"
            >
                <div class="flex-1">
                    <div
                        class="text-brand-900 flex size-12 items-center justify-center rounded-xl bg-zinc-100"
                        aria-hidden="true"
                    >
                        <component
                            class="size-6"
                            :is="addon.icon"
                            stroke-width="1.5"
                        />
                    </div>

                    <h3 class="text-brand-900 mt-8 text-2xl font-extrabold tracking-tight md:text-3xl">
                        {{ addon.name }}
                    </h3>

                    <p class="mt-3 text-base leading-relaxed text-zinc-600">
                        {{ addon.description }}
                    </p>

                    <ul class="mt-8 space-y-3 text-base text-zinc-700">
                        <li
                            class="flex items-start gap-3"
                            v-for="feature in addon.features"
                            :key="feature"
                        >
                            <CheckIcon
                                class="text-brand-900 mt-0.5 size-5 shrink-0"
                                stroke-width="2"
                                aria-hidden="true"
                            />
                            <span>
                                {{ feature }}
                            </span>
                        </li>
                    </ul>
                </div>

                <div
                    class="mt-10 md:mt-0 md:flex md:w-64 md:shrink-0 md:flex-col md:justify-center md:border-l md:border-zinc-100 md:pl-12"
                >
                    <p class="text-brand-900 text-3xl font-extrabold tracking-tight md:text-4xl">
                        {{ addonsStartingPrice }}
                    </p>

                    <BrandButton
                        class="mt-6"
                        href="#contact"
                        block
                        @click="requestAddon"
                    >
                        Mám zájem
                    </BrandButton>
                </div>
            </article>
        </div>
    </section>
</template>
